const video = {

	elem: {
		body: document.querySelector('body'),
		vmodalButton: document.querySelectorAll('.media .btn-link, .vmodal .btn-link'),
		vmodalDialog: document.querySelectorAll('dialog.vmodal-modal'),
		vbgButton: document.querySelectorAll('.vbg .toggle-btn')
	},

	init() {
		// Video Modals
		if (this.elem.vmodalButton.length > 0) {
			video.elem.vmodalButton.forEach(function(element) {
				element.addEventListener('click', video.open);
			});			
			video.elem.vmodalDialog.forEach(function(element) {
				element.addEventListener('click', video.close);
				element.addEventListener('close', video.reset);
			});			
		}

		// Video Backgrounds
		if (this.elem.vbgButton.length >  0) {
			video.elem.vbgButton.forEach(function(element) {
				element.addEventListener('click', video.toggle);
			});			
		}
	},

	// VIDEO MODAL FUNCTIONS
	// close(): close closest modal window to clicked element
	close(event) {
		let modal = event.target.closest('.vmodal-modal');
		modal.close();
	},

	// open(): add modal-open class to body, populate closest modal to clicked element with an iframe video pointing at the correct video service, and then open it
	open(event) {
		event.preventDefault();
		let href = event.target.href;
		let parent = event.target.closest('.vmodal');
		let modal = '';
		let id = '';
		let src= '';
		if (parent === null) {
			modal = event.target.closest('.media').querySelector('.vmodal-modal');
		} else {
			modal = parent.nextElementSibling;
		}
		video.elem.body.classList.add('modal-open');	
		if (href.indexOf('vimeo.com') > -1) {
			id = href.split('/');
			if(id.length > 4) {
				src = 'https://player.vimeo.com/video/' + id[3] + '?h=' + id[4] + '&autoplay=1'
			} else {
				src = 'https://player.vimeo.com/video/' + id[3] + '?autoplay=1'
			}
		}
		if (href.indexOf('player.vimeo.com') > -1) {
			id = href.split('/')[4];
			src = 'https://player.vimeo.com/video/' + id + '?autoplay=1'
		}
		if (href.indexOf('youtube.com') > -1) {
			id = href.substr(href.indexOf('=') + 1);
			src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&modestrbranding=1&rel=0'
		}
		if (href.indexOf('youtu.be') > -1) {
			id = href.substr(17);
			id = id.split('?')[0];
			src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&modestrbranding=1&rel=0'
		}		
		modal.innerHTML += '<iframe class="vmodal__iframe" frameborder="0" allow="autoplay" allow="autoplay; clipboard-write; encrypted-media; fullscreen; web-share" allowfullscreen referrerpolicy="strict-origin-when-cross-origin" sandbox="allow-same-origin allow-scripts allow-presentation" src="' + src + '"></iframe>';
		modal.showModal();
		modal.querySelector('.vmodal-modal__close').addEventListener('click', video.close);	
	},

	// reset(): when closing a modal closed empty it of content and remove modal-open class from body
	reset(event) {
		let modal = event.target;
		modal.removeChild(modal.querySelector('iframe'));
		video.elem.body.classList.remove('modal-open');
	},

	// VIDEO BACKGROUND FUNCTIONS
	// toggle(): toggles plays state of background video
	toggle(event) {
		event.preventDefault();
		let pressed = event.target.getAttribute('aria-pressed');
		let label = event.target.getAttribute('aria-label');
		pressed = (pressed === 'true') ? 'false' : 'true';
		label = label.indexOf('Play') > -1 ? label.replace('Play', 'Pause') : label.replace('Pause', 'Play');
		event.target.setAttribute('aria-pressed', pressed);
		event.target.setAttribute('aria-label', label);
		if (pressed === 'true') {
			event.target.closest('.vbg').querySelector('video').pause();
		} else {
			event.target.closest('.vbg').querySelector('video').play();
		}
	}
};

export { video };
